<template>
  <div id="photos">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left :to="{ path: '/albums'}" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>   
          <v-btn v-if="album.type !== 'Avatar'" fab absolute right class="mr-3 pf-btn-fab" @click="addImage">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="isListEmpty" class="text-center">
        <img src="static/NoPictures.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Photo(s) Found !! </b></h4>
    </v-container>
    <v-container grid-list-md fluid v-if="photoList.length > 0">
      <draggable v-model="photoList" class="layout wrap row" handle=".handle" @start="drag=true" @end="drag=false;" @change="updateSort" forceFallback= "false">
        <v-flex v-for="(photo, i) in photoList" :key="photo.id" xs12 sm6 md4 lg3 pa-2>
          <v-card flat tile hover v-if="photo">
              <div class="image_class" :id="`photo-${photo.id}`" :style="`background-image: url('${photo.thumb_url}');`" :alt="photo.caption" @click="viewItem(i)">
                <div v-if="typeof photo.approved !== 'undefined' && !photo.approved" class="pf-photo-pending-label">PENDING APPROVAL</div>
              </div>
              <v-flex class="pl-1 pr-1 mb-1">
                <h5 v-if="isSave == false || currentEditor != photo.id" id="albumName" class="pa-1 title-display">
                  <div v-on:click="showPhotoEdit(photo);">
                    <span v-if="photo.caption">{{ photo.caption }}</span>
                    <span v-else>Add Caption</span>
                </div>
                  </h5>
                <v-text-field v-if="isSave && currentEditor == photo.id" v-model.trim="photo.caption" autofocus :hide-details="true" 
                class="pr-1 pt-1 text-edit-field" height="20" @change="saveEdited"></v-text-field>
              </v-flex>
              <v-divider horizontal class="pf-divider"></v-divider>
              <v-layout>
              <v-flex flat class="xs12 sm2 pl-2 pr-0">
                <v-btn icon small class="mr-0 ml-0" v-if="photo.size > config.imageQuality">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-icon size="22" color="green" v-on="on">fiber_manual_record</v-icon>
                    </template>
                    <span>Good Quality</span>
                  </v-tooltip>
                </v-btn>
                <v-btn icon small class="mr-0 ml-0" v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-icon size="22" color="orange" v-on="on">fiber_manual_record</v-icon>
                  </template>
                    <span>Low Quality</span>
                  </v-tooltip>
                </v-btn>
              </v-flex>
              <v-flex flat class="xs12 sm10 pl-0 pr-2 text-xs-right">
                <!-- <v-btn icon small class="mr-0 ml-0 handle" @click="setProfilePic(photo)" v-if="photo.thumb_url !== accountDetails.avatar">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon size="22" color="grey darken-2" v-on="on">account_circle</v-icon>
                    </template>
                    <span>Profile Pic</span>
                </v-tooltip>
                </v-btn>
                <v-btn icon small class="mr-0 ml-0 handle" v-if="photo.thumb_url === accountDetails.avatar">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon size="22" color="pink lighten-3" v-on="on">account_circle</v-icon>
                    </template>
                    <span>Profile Pic</span>
                  </v-tooltip>
                </v-btn> -->
                <v-btn icon small class="mr-0 ml-0" v-if="defaultPhoto && photo.id === defaultPhoto.id">
                    <v-icon size="22" color="pink lighten-3">star</v-icon>
                </v-btn>
                <v-btn icon small class="mr-0 ml-0" @click="setCoverPic(photo);" v-if="!defaultPhoto || photo.id !== defaultPhoto.id">
                    <v-icon size="22" color="grey darken-2"
                    >star_border</v-icon>
                </v-btn>
                <v-btn icon small class="mr-0 ml-0 handle">
                  <v-icon size="22" color="grey darken-2">open_with</v-icon>
                </v-btn>
                <v-btn icon small class="mr-0 ml-0" v-if="photo.thumb_url !== (session.role() === 'child' ? Child.avatar : Account.avatar)" @click="deletePhoto(photo)">
                  <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                </v-btn>
                <v-menu v-if="photo.thumb_url !== (session.role() === 'child' ? Child.avatar : Account.avatar)" offset-y >
                <template v-slot:activator="{ on }">
                <v-btn icon small class="mr-0 ml-0" v-on="on">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                    </template>
                    <span>More</span>
                  </v-tooltip>
                </v-btn>
                </template>
                <v-list>
                  <v-list-tile v-if="album.type === 'Avatar' ? false : true" @click="editPhoto(photo);">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">edit</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Edit
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="album.type === 'Avatar' ? false : true" @click="downloadPhoto(photo)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0" >
                        <v-icon size="22" color="grey darken-2">save_alt</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Download
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="makeAvatar(photo);">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">image</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Use as Avatar
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="album.type === 'Avatar' ? false : true" @click.stop="movePhoto(photo)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0" >
                        <v-icon size="22" color="grey darken-2">attachment</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Move to Album
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </draggable>
      <v-layout row justify-center>
        <v-dialog 
          persistent 
          no-click-animation
          v-model="slideModal"
          max-width="1000"
          content-class="elevation-0"
        >
          <v-card color="transparent" class="elevation-0">
            <v-btn v-if="!slideInactive" class="white--text slider-close-btn" icon @click="slideModal = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-card-text class="pa-0">
              <v-layout wrap row>
                <v-flex xs12>
                  <v-carousel 
                    hide-delimiters
                    :hide-controls="slideInactive"
                    :cycle="false"
                    :value="slideIndex"
                    @change="slideChange"
                    height="62vh"
                    class="slide-box slide-box-popup elevation-0"
                  >
                    <v-carousel-item
                      v-for="(item,i) in photoList"
                      :key="i"
                    >
                      <div class="text-xs-center">
                        <img :src="item.webview_url" class="carousel-custom-image">
                      </div>
                    </v-carousel-item>
                  </v-carousel>
                </v-flex>
                <v-flex xs12 pt-2 fixed-height-100>
                  <v-tabs
                    dark
                    show-arrows
                    centered
                    class="slider-tab"
                    color="transparent"
                  >
                    <v-tab
                      v-for="(item,i) in photoList"
                      :key="i"
                      @click="slideChange(i)"
                      :value="slideIndex"
                    >
                      <v-card flat light tile class="d-inline-flex pa-1"
                        max-width="20vh"
                        :class="{'pf-bg-green': slideIndex === i}"
                      >
                        <img
                          :src="item.thumb_url"
                          class="grey lighten-2"
                          contain
                          height="100%"
                          width="100%"
                        >
                      </v-card>
                    </v-tab>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap >
              <v-flex v-for="albumItem of this.Album" :key="albumItem.id" xs12 sm6 pa-2 v-show="albumItem.type === 'Normal' && albumItem.id !== albumId">
               <v-radio-group v-model="moveAlbum" row >
                <v-card>
                  <v-card-text>
                    <v-radio :label="albumItem.name" color="primary" :value="albumItem.id"></v-radio>
                  </v-card-text>
                </v-card>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" >
              <v-btn class="pf-btn pf-btn-cancel" @click="dialog = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="moveNewAlbum(moveAlbum)">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Move</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
    </v-container>
  </div>
</template>
<script>
/* global session store config */

import swal from 'sweetalert2';
import { getOne, create, update, remove, sortList, updateSortList, getCollection, request } from '../helpers/helpers';
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import $ from 'jquery';

export default {
  components: {
    draggable,
  },
  data: () => ({
    entity: 'Photo',
    roleEntity: 'Account',
    isListEmpty: false,
    slideIndex: 0,
    slideInactive: true,
    imageCaption: '',
    caption: false,
    isSave: false,
    isCoverPic: 1,
    currentEditor: 0,
    dialog: false,
    slideModal: false,
    accountId: '',
    albumId: '',
    albumName: '',
    currentEditorIndex: null,
    defaultPhoto: '',
    albumIndex: 0,
    album: {},
    photoList: [],
    accountDetails: {},
    newAlbum: {
      src: '/static/album-icon.jpg',
    },
    moveAlbum: '',
    currentPhoto: [],
    config: config
  }),
  computed: {
    ...mapGetters(['AlbumPhoto', 'Account', 'Child']),
    albumType: {
      get () {
        if (this.album) {
          return this.album.type || 'Normal';
        }
      }
    },
    Album: {
      get () {
        return store.state.Album;
      },
      set (value) {
        store.commit('setAlbum', value);
      }
    },
    Task: {
      get () {
        return store.state.Task;
      },
      set (value) {
        store.commit('setTask', value);
      }
    },
    Timeline: {
      get () {
        return store.state.Timeline;
      },
      set (value) {
        store.commit('setTimeline', value);
      }
    }
  },
  async created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    this.albumId = this.$route.params.id;
    if (!this.Album.length && this[this.roleEntity].album.length > 0) {
      await this.fetchAlbum();
    }
    this.accountDetails = this[this.roleEntity];
    await this.initialize();
    if (this.photoList.length === 0) this.isListEmpty = true;
  },
  mounted () {
    // eslint-disable-next-line
    window.getApp.$on('NEW_ALBUM_PHOTO', messageEvent => {
      this.isListEmpty = false;
      console.log('------------>>>>>>>', 'Album Photo', messageEvent);
      if (messageEvent.data) {
        let albumId = messageEvent.data.album;
        let newImages = messageEvent.data;
        let existingImage = false;
        let existingAlbumImage = false;
        if (this[this.roleEntity].avatar_album === albumId) {
          if (newImages.approved) {
            if (newImages.filename && newImages.filename.indexOf('_siblingavatar_') === -1) {
              this.accountDetails.avatar = newImages.thumb_url;
            }
          } else {
            this.accountDetails.temp_avatar = newImages.thumb_url;
          }
          store.commit(`set${this.roleEntity}`, this.accountDetails);
        }
        else if (this[this.roleEntity].banner_album === albumId) {
          if (newImages.approved) {
            this.accountDetails.banner_photo = newImages.original_url;
          } else {
            this.accountDetails.temp_banner = newImages.original_url;
          }
          store.commit(`set${this.roleEntity}`, this.accountDetails);
        } else if (this[this.roleEntity].mobile_banner_album && this[this.roleEntity].mobile_banner_album === albumId) {
          if (newImages.approved) {
            this.accountDetails.mobile_banner = newImages.original_url;
          } else {
            this.accountDetails.temp_mobile_banner = newImages.original_url;
          }
          store.commit(`set${this.roleEntity}`, this.accountDetails);
        } else {
          if (!this.AlbumPhoto[albumId]) {
            this.AlbumPhoto[albumId] = [];
          }
          if (this.AlbumPhoto[albumId].length > 0) {
            if (this.AlbumPhoto[albumId].find(item => item.id === newImages.id)) {
              existingImage = true;
            }
            if (!existingImage) {
              this.AlbumPhoto[albumId].push(newImages);
            }
          }
          else {
            this.AlbumPhoto[albumId].push(newImages);
          }
          if (!this.album.default_photo) {
            this.album.defaultPhoto = { ...newImages };
          }
          if (!this.defaultPhoto) {
            this.defaultPhoto = newImages;
          }
          if (this.Album.length) {
            let newAlbumPhoto = {
              photo: newImages.id,
              sort_no: 0
            };
            const albumIndex = this.Album.findIndex(item => item.id === albumId);
            if (this.Album[albumIndex].photo.find(item => item.photo === newImages.id)) {
              existingAlbumImage = true;
            }
            if (albumIndex > -1) {
              if (this.Album[albumIndex].photo.length === 0) {
                this.Album[albumIndex].default_photo = { ...newImages };
              }
              if (!existingAlbumImage) {
                this.Album[albumIndex].photo.push(newAlbumPhoto);
              }
            }
            this.photoList = sortList(this.entity, [...this.AlbumPhoto[albumId]], 'Album', this.albumId);
          } else {
            this.photoList = sortList(this.entity, [...this.AlbumPhoto[albumId]], 'Album', this.albumId, this.album.photo);
          }
          this.album = this.Album.find(item => item.id === this.albumId);
        } 
      }
    });
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async initialize () {
      if (this.albumId === this[this.roleEntity].avatar_album || !this.AlbumPhoto[this.albumId]) {
        let { error, data } = await getOne('Album', this.albumId);
        if (error) {
          console.log('error', error);
        } else {
          const photos = [];
          for (let i = 0; i < data.photo.length; i++) {
            if (typeof data.photo[i].photo !== 'undefined' && data.photo[i].photo && data.photo[i].photo.id) {
              photos.push(data.photo[i].photo);
              data.photo[i].photo = data.photo[i].photo.id;
            }
          }
          this.album = data;
          this.AlbumPhoto[this.albumId] = photos;
          this.photoList = sortList(this.entity, [...this.AlbumPhoto[this.albumId]], 'Album', this.albumId, data.photo);
          this.albumName = data.name;
          this.defaultPhoto = data.default_photo;
        }
      } else {
        const album = this.Album.find(item => item.id === this.albumId);
        this.album = { ...album };
        this.photoList = sortList(this.entity, [...this.AlbumPhoto[this.albumId]], 'Album', this.albumId);
        this.albumName = this.album.name;
        this.defaultPhoto = this.album.default_photo;
        
      }
      const album = this.Album.find(item => item.id === this.albumId);
      window.getApp.$emit('pageSubHeader', this.albumName);
    },
    async fetchAlbum () {
      if (!this.Album.length) {
        let entity = 'Album';
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
        }
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.Album = sortList(this.entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
            if (this.Album.filter(item => (item.type === 'Normal') || (item.type === 'Profile') || (item.type === 'Avatar')).length === 0) {
              this.isListEmpty = true;
            }
          } else {
            this.isListEmpty = true;
          }
        }
      } else {
        if (this.Album.filter(item => (item.type === 'Normal') || (item.type === 'Profile') || (item.type === 'Avatar')).length === 0) {
          this.isListEmpty = true;
        }
        // Remove the green border for the new album
        if (this.Album.length && this.Album[0].setNew && this.Album[0].setNew === true) {
          delete this.Album[0].setNew;
        }
      }
    },
    editCaption () {
      this.caption = true;
    },
    showPhotoEdit (item) {
      this.currentEditorIndex = this.photoList.indexOf(item);
      this.currentEditor = item.id;
      this.isSave = true;
      this.editData = item;
    },
    hideAlbumEdit () {
      this.currentEditor = 0;
      this.isSave = false;
    },
    addImage () {
      const client = global.filestack.init(this.config.filestack.client);
      const humanId = session.user().human.id;
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 20,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        storeTo: {
          location: 'S3',
          path: '/' + this.config.s3Domain + '/' + humanId + '/album/' + this.albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: async (response) => {
          if (this[this.roleEntity].task && this[this.roleEntity].task.length) {
            let uploadTask = this[this.roleEntity].task.filter(task => task.name === 'Upload photos for your design book' && ['Open', 'In-Progress'].indexOf(task.status) > -1);
            if (uploadTask.length) {
              swal.fire({
                title: 'Upload finished?',
                text: 'Have you completed all of your photo uploads for your design book ?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, completed!'
              }).then(result => {
                if (result.value) {
                  this.saveTaskStatus(this[this.roleEntity].task.indexOf(uploadTask[0]), 'Closed');
                }
              });
            }
          }

          if (response.filesUploaded && response.filesUploaded.length) {

            /* Notify the agency on photo upload - based on the agency settings */
            let notifyPayload = {
              no_of_photos: response.filesUploaded.length,
              album_name: this.album.name
            };
            notifyPayload[this.roleEntity.toLowerCase()] = this[this.roleEntity].id;
            
            let { error: notifyError, data: notifyData } = await request('Email/notifyAlbumPhotoUpload', 'POST', notifyPayload);
          }
        }
      };
      client.picker(options).open();
    },
    async saveEdited () {
      if (this.currentEditorIndex != null) {
        let editorIndex = { ...this.currentEditorIndex };
        let editedData = JSON.parse(JSON.stringify(this.editData));
        this.currentEditorIndex = null;
        let { error, data, status } = await update(
          this.entity,
          editedData,
          editedData._id || editedData.id
        );
        if (error) {
          console.log('error', error);
        } else {
          this.photoList[editorIndex] = data;
          this.currentEditor = null;
          this.loading = false;
          editorIndex = null;
          swal.fire({
            type: 'success',
            title: 'Caption updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.isSave = false;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    async deletePhoto (item) {
      if (item.letter.length) {
        swal.fire({
          type: 'warning',
          title: 'Letter Image',
          text: 'This image is used in one of the letters',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }
      else {
        /* Check if the photo is linked to profile document */
        let conditions = {
          $or:
          [
            { 'chapters.items.photo': item.id },
            { 'special_pictures.back_cover.photo': item.id },
            { 'special_pictures.center_spread.photo': item.id },
            { 'special_pictures.front_cover.photo': item.id }
          ]
        };
        let { error, data } = await getCollection('ProfileDocument', true, 0, '', conditions);
        if (error) {
          console.log('error', error);
          return;
        } else {
          if (data.length > 0) {
            swal.fire({
              type: 'warning',
              title: 'Profile Image',
              text: 'You cannot delete an image linked to the profile chapter',
              showConfirmButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            });
            return;
          }
        }

        swal.fire({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(result => {
          if (result.value) {
            (async () => {
              let { error, data, status } = await remove(this.entity, item.id);
              if (error) {
                console.log('error', error);
              } else {
                const albumIndex = this.Album.findIndex(item => item.id === this.albumId);
                const index = this.photoList.indexOf(item);
                this.photoList.splice(index, 1);
                if (this.photoList.length === 0) this.isListEmpty = true;
                this.Album[albumIndex].photo.splice(index, 1);
                this.AlbumPhoto[this.albumId].splice(index, 1);
                if (this.Album[albumIndex].default_photo.id === item.id && this.Album[albumIndex].photo.length) {
                  this.Album[albumIndex].default_photo = this.AlbumPhoto[this.albumId][0];
                  this.defaultPhoto = this.AlbumPhoto[this.albumId][0];
                }
                if (this.Album[albumIndex].photo.length === 0) {
                  this.Album[albumIndex].default_photo = [];
                }
                swal.fire(
                  'Deleted!',
                  'Photo has been deleted.',
                  'success'
                );
              }
            })();
          }
        });
      }
    },
    editPhoto (item) {
      window.getApp.$emit('photoEdit', true, item);
    },
    async setCoverPic (item) {
      this.defaultPhoto = item;
      this.album.default_photo = { ...item };
      let { error, data, status } = await update('Album', this.album, this.albumId);
      if (error) {
        console.log('error', error);
      } else {
        const albumIndex = this.Album.findIndex(item => item.id === this.albumId);
        if (albumIndex > -1) {
          this.Album[albumIndex].default_photo = { ...item };
        }
        this.loading = false;
        swal.fire({
          type: 'success',
          title: 'Cover photo updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            // this.selectedData = false;
          }
        });
      }
    },
    async saveTaskStatus (taskIndex, taskStatus) {
      if (taskIndex > -1 && taskStatus) {
        let task = await this[this.roleEntity].task[taskIndex];
        task.status = taskStatus;
        this[this.roleEntity].task.splice(taskIndex, 1, task);
        this[this.roleEntity].updated_from = 'tasks';
        const updateId = session.getSession().user.human[this.roleEntity.toLowerCase()]._id || session.getSession().user.human[this.roleEntity.toLowerCase()].id;
        let { error, data, status } = await update(this.roleEntity, this[this.roleEntity], updateId);
        if (error) {
          console.log('error', error);
        } else {
          store.commit(`set${this.roleEntity}`, data);
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Task updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.setTaskStatus(taskStatus, task);
            }
          });
        }
      }
    },
    async setTaskStatus (taskStatus, taskData) {
      let timelineObj = {};
      if (taskData.last_timeline) {
        taskData.last_timeline.status = taskStatus;
      } else {
        taskData.last_timeline = { status: taskStatus };
      }
      timelineObj = {
        'text': `You completed the task '${taskData.name}'`,
        'title': 'Task Completed',
        'task': taskData._id,
        'status': taskStatus,
        'description': taskData.description ? taskData.description : '',
        'links': taskData.last_timeline.links ? taskData.last_timeline.links : [],
        'icon': 'check',
        'color': 'green',
      };
      this.updateTimeline(timelineObj, taskData);
    },
    async updateTimeline (timelineObj, taskData) {
      if (session.getSession().adminUser) {
        timelineObj[this.roleEntity.toLowerCase()] = session.getSession().user.human[this.roleEntity.toLowerCase()].id;
      }
      let { error, data } = await create('Timeline', timelineObj);
      if (error) {
        console.log('error', error);
      } else {
        let newTimelineItem = Object.assign(data, timelineObj);

        if (taskData.last_timeline && !taskData.last_timeline._id) {
          taskData.last_timeline = newTimelineItem;
          this.Task[this.Task.indexOf(taskData)].last_timeline = newTimelineItem;
        }

        timelineObj.text = taskData.last_timeline.text;
        let result = await update('Timeline', timelineObj, taskData.last_timeline.id);
        if (result.error) {
          console.log('result.error', error);
        } else {
          let newTimelineItem = Object.assign(result.data, timelineObj);

          if (!taskData.last_timeline) {
            taskData.last_timeline = newTimelineItem;
            this.Task[taskData.index].last_timeline = newTimelineItem;
          }
        }
        this.Timeline.unshift(newTimelineItem);
        // this.statusChange = false;
        // this.getTasks();
      }
    },
    async setProfilePic (item) {
      this.accountDetails.avatar = item.thumb_url;
      let entity = this.roleEntity;
      this.accountDetails.updated_from = 'avatar';
      const updateId = session.getSession().adminUser ? (session.getSession().user.human[this.roleEntity.toLowerCase()]._id || session.getSession().user.human[this.roleEntity.toLowerCase()].id) : 'Me';
      let { error, data, status } = await update(entity, this.accountDetails, updateId);
      if (error) {
        console.log('error', error);
      } else {
        this.loading = false;
        this[this.roleEntity].avatar = this.accountDetails.avatar;
        store.commit(`set${this.roleEntity}`, this.accountDetails);
        swal.fire({
          type: 'success',
          title: 'Avatar photo updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            //
          }
        });
      }
    }, 
    async setBannerImage (item) {
      this.accountDetails.banner_photo = item.original_url;
      this.accountDetails.updated_from = 'albums';
      let entity = this.roleEntity;
      const updateId = session.getSession().adminUser ? (session.getSession().user.human[this.roleEntity.toLowerCase()]._id || session.getSession().user.human[this.roleEntity.toLowerCase()].id) : 'Me';
      let { error, data, status } = await update(entity, this.accountDetails, updateId);
      if (error) {
        console.log('error', error);
      } else {
        this.loading = false;
        this[this.roleEntity].banner_photo = this.accountDetails.banner_photo;
        swal.fire({
          type: 'success',
          title: 'Banner updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            //
          }
        });
      }
    }, 
    async makeAvatar (photo) {
      if (this[this.roleEntity].avatar_album === photo.album) {
        this.setProfilePic(photo);
      } else {
        window.getApp.$emit('imageCrop', true, photo);
      }
    },
    downloadPhoto (photo) {
      let hostHttps = window.location.origin.indexOf('https');
      let newUrl = '';
      if (hostHttps === -1) {
        newUrl = photo.original_url.replace('https', 'http');
      }
      else {
        newUrl = photo.original_url;
      }
      this.downloadItem(newUrl, photo.filename);
    },
    downloadItem (url, fileName) {
      swal.fire({
        type: 'success',
        title: 'Image is downloading... please wait',
        showConfirmButton: false,
        timer: 2500,
        onClose: () => {
          //
        }
      });
      $.ajax({
        url: url,
        cache: false,
        xhrFields: {
          responseType: 'blob'
        },
        success: function (data) {
          const blob = new Blob([data], { type: 'image/jpg' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        },
        error: function () {
          // error
        }
      });
    },
    viewItem (index) {
      this.slideInactive = true;
      this.slideModal = true;
      this.slideIndex = index;
      setTimeout(() => {
        this.slideInactive = false;
        window.dispatchEvent(new Event('resize'));
      }, 500);
    },
    slideChange (index) {
      this.slideIndex = index;
    },
    updateSort () {
      if (this.Album.length) {
        updateSortList('Photo', this.photoList, 'Album', this.albumId);
      } else {
        updateSortList('Photo', this.photoList, 'Album', this.albumId, this.album);
      }
    },
    async moveNewAlbum (itemAlbum) {
      if (itemAlbum) {
        this.dialog = false;
        let currentPhotoId = this.currentPhoto.id;
        let entity = `Photo`;
        const destinationAlbum = this.Album.find(item => item.id === itemAlbum);
        let NewAlbum = this.currentPhoto;
        NewAlbum.album = itemAlbum;
        let { error, data, status } = await update(entity, NewAlbum, this.currentPhoto._id || this.currentPhoto.id);
        if (error) {
          console.log('error', error);
        } else {
          const index = this.photoList.indexOf(this.currentPhoto);
          const albumIndex = this.Album.findIndex(item => item.id === this.albumId);
          this.photoList.splice(index, 1);
          this.Album[albumIndex].photo.splice(index, 1);
          this.AlbumPhoto[this.albumId].splice(index, 1);
          if (this.AlbumPhoto[itemAlbum]) {
            this.AlbumPhoto[itemAlbum].push(data);
          }
          let destAlbumPhoto = [
            photo => data.id,
            sort_no => 0
          ];
          destinationAlbum.photo.push(destAlbumPhoto);
          if (destinationAlbum.default_photo === undefined || (typeof destinationAlbum.default_photo !== undefined && destinationAlbum.default_photo.length === 0)) {
            destinationAlbum.default_photo = { ...data };
          }
          if (this.Album[albumIndex].default_photo.id === currentPhotoId && this.Album[albumIndex].photo.length > 0) {
            this.Album[albumIndex].default_photo = { ...this.AlbumPhoto[this.albumId][0] };
            this.defaultPhoto = { ...this.AlbumPhoto[this.albumId][0] };
          }
          if (this.Album[albumIndex].photo.length === 0) {
            this.Album[albumIndex].default_photo = [];
          }
          swal.fire({
            type: 'success',
            title: 'Image moved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.moveAlbum = '';
            }
          });
        }
      }
      else {
        swal.fire(`Please select an album`);
      }
    },
    async movePhoto (item) {
      let items = [];
      this.currentPhoto = item;
      let count = 0;
      for (let i = 0; i < this.Album.length; i++) {
        if (this.Album[i].type === 'Normal' && this.Album[i].id !== this.albumId) {
          items[this.Album[i].id] = this.Album[i].name;
          count++;
        }
      }
      if (count > 0) {
        const { value: destinationAlbum } = await swal.fire({
          title: 'Move to album',
          input: 'select',
          inputOptions: items,
          inputPlaceholder: 'Select an album',
          showCancelButton: true,
          confirmButtonText: 'Move',
          customClass: {
            confirmButton: 'pf-btn pf-btn-save saveCancel-btn',
            cancelButton: 'pf-btn pf-btn-cancel saveCancel-btn'
          },
          inputValidator: (value) => {
            if (!value) {
              return 'Please select an album!';
            }
          }
        });
        if (destinationAlbum) {
          this.moveNewAlbum(destinationAlbum);
        }
      }
      else {
        swal.fire(`You have no other album to move this photo`);
      }
    }
  }
};
</script>
<style scoped>
.button_div{
  min-height:60px;
  position: relative
}
.title-display{
  padding-top: 6px !important;
}
.text-edit-field {
  padding-left: 4px;
  padding-bottom: 6px;
}
.image_class{
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 240px;
}
.fixed-height-100 {
  white-space:nowrap; 
  overflow-x: auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/Photos.vue